import { Builder } from '@builder.io/react';

import AcaQuiz from './aca-quiz';

Builder.registerComponent(AcaQuiz, {
  name: 'ACAQuiz',
  friendlyName: 'ACA Quiz',
  noWrap: true,
  inputs: [
    {
      name: 'incomeThreshold',
      type: 'number',
      defaultValue: 50000,
      friendlyName: 'Income Threshold',
    },
    {
      name: 'redirectUrlDefault',
      type: 'string',
      defaultValue:
        'https://www.healthcare.com/medicare-supplement/survey/coverage-urgency/',
      friendlyName: 'Default Redirect URL',
    },

    {
      name: 'redirectUrlMedU64',
      type: 'string',
      defaultValue:
        'https://www.healthcare.com/healthcare-insurance/survey/immediate-coverage/',
      friendlyName: 'Redirect URL for U64+Medicare/Medicaid',
    },
  ],
});
